/**
 * Realizacje Gallery - Grid Packing & Tab Filtering
 * Wzorzec z designu: powtarzalny układ 3x2, 4x1, 5x2
 */

(function() {
    'use strict';

    const GRID_COLUMNS = 12;
    
    // Deterministyczny wzorzec z designu (powtarza się co 4 rzędy, 8 elementów)
    const PATTERN = [
        // Rząd 1-2
        { cols: 3, rows: 2, name: '3x2' },  // [1]  kol 1-3,   rzędy 1-2
        { cols: 4, rows: 1, name: '4x1' },  // [2]  kol 4-7,   rząd 1
        { cols: 5, rows: 2, name: '5x2' },  // [3]  kol 8-12,  rzędy 1-2
        { cols: 4, rows: 1, name: '4x1' },  // [4]  kol 4-7,   rząd 2
        // Rząd 3-4
        { cols: 5, rows: 2, name: '5x2' },  // [5]  kol 1-5,   rzędy 3-4
        { cols: 3, rows: 2, name: '3x2' },  // [6]  kol 6-8,   rzędy 3-4
        { cols: 4, rows: 1, name: '4x1' },  // [7]  kol 9-12,  rząd 3
        { cols: 4, rows: 1, name: '4x1' },  // [8]  kol 9-12,  rząd 4
    ];

    // Dokładne pozycje każdego elementu w cyklu (col, row - 0-indexed)
    const PATTERN_POSITIONS = [
        { col: 0, row: 0 },   // 3x2  -> kol 1-3, rzędy 1-2
        { col: 3, row: 0 },   // 4x1  -> kol 4-7, rząd 1
        { col: 7, row: 0 },   // 5x2  -> kol 8-12, rzędy 1-2
        { col: 3, row: 1 },   // 4x1  -> kol 4-7, rząd 2
        { col: 0, row: 2 },   // 5x2  -> kol 1-5, rzędy 3-4
        { col: 5, row: 2 },   // 3x2  -> kol 6-8, rzędy 3-4
        { col: 8, row: 2 },   // 4x1  -> kol 9-12, rząd 3
        { col: 8, row: 3 },   // 4x1  -> kol 9-12, rząd 4
    ];

    const PATTERN_CYCLE_ROWS = 4; // Wzorzec zajmuje 4 rzędy

    class RealizationsGallery {
        constructor(container) {
            this.container = container;
            this.grid = container.querySelector('[data-gallery-grid]');
            this.tabs = container.querySelectorAll('.gallery__tab');
            this.items = Array.from(this.grid.querySelectorAll('.gallery__item'));
            this.currentCategory = 'all';
            this.animationDelay = 50;
            
            this.init();
        }

        init() {
            if (!this.grid || this.items.length === 0) return;

            this.tabs.forEach(tab => {
                tab.addEventListener('click', () => this.handleTabClick(tab));
            });

            this.updateLayout();
            this.initScrollAnimations();
            
            // Wycentruj aktywny tab po załadowaniu
            setTimeout(() => {
                const activeTab = document.querySelector('.gallery__tab.active');
                if (activeTab) {
                    this.centerActiveTab(activeTab);
                }
            }, 100);

            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    this.updateLayout();
                }, 250);
            });
        }

        handleTabClick(tab) {
            const category = tab.dataset.category;
            if (category === this.currentCategory) return;

            this.tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            
            // Wycentruj aktywny tab
            this.centerActiveTab(tab);

            this.animateOut(() => {
                this.currentCategory = category;
                this.updateLayout();
                this.animateIn();
            });
        }
        
        centerActiveTab(tab) {
            const tabsContainer = tab.closest('.gallery__tabs');
            if (!tabsContainer) return;
            
            const tabRect = tab.getBoundingClientRect();
            const containerRect = tabsContainer.getBoundingClientRect();
            
            const tabCenter = tabRect.left + tabRect.width / 2;
            const containerCenter = containerRect.left + containerRect.width / 2;
            const scrollOffset = tabCenter - containerCenter;
            
            tabsContainer.scrollBy({
                left: scrollOffset,
                behavior: 'smooth'
            });
        }

        updateLayout() {
            const visibleItems = this.getVisibleItems();
            const gridMap = this.packItems(visibleItems);
            
            this.items.forEach(item => {
                const isVisible = visibleItems.includes(item);
                item.style.display = isVisible ? 'block' : 'none';
            });

            visibleItems.forEach((item, index) => {
                const placement = gridMap[index];
                if (placement) {
                    item.style.gridColumn = `${placement.col} / span ${placement.cols}`;
                    item.style.gridRow = `${placement.row} / span ${placement.rows}`;
                    item.dataset.shape = placement.shape;
                }
            });
        }

        getVisibleItems() {
            if (this.currentCategory === 'all') {
                return this.items;
            }
            return this.items.filter(item => 
                item.dataset.category === this.currentCategory
            );
        }

        packItems(items) {
            const gridMap = [];

            items.forEach((item, index) => {
                const patternIndex = index % PATTERN.length;
                const shape = PATTERN[patternIndex];
                const position = PATTERN_POSITIONS[patternIndex];
                const cycleNumber = Math.floor(index / PATTERN.length);
                const actualRow = position.row + (cycleNumber * PATTERN_CYCLE_ROWS) + 1;
                const actualCol = position.col + 1;

                gridMap[index] = {
                    col: actualCol,
                    row: actualRow,
                    cols: shape.cols,
                    rows: shape.rows,
                    shape: shape.name
                };
            });

            return gridMap;
        }

        animateOut(callback) {
            const visibleItems = this.items.filter(item => 
                item.style.display !== 'none'
            );

            visibleItems.forEach((item, index) => {
                setTimeout(() => {
                    item.style.opacity = '0';
                    item.style.transform = 'scale(0.9) translateY(20px)';
                }, index * 20);
            });

            setTimeout(callback, visibleItems.length * 20 + 300);
        }

        animateIn() {
            const visibleItems = this.getVisibleItems();

            visibleItems.forEach((item, index) => {
                setTimeout(() => {
                    item.style.opacity = '1';
                    item.style.transform = 'scale(1) translateY(0)';
                }, index * this.animationDelay);
            });
        }

        initScrollAnimations() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const item = entry.target;
                        const index = parseInt(item.dataset.index);
                        
                        setTimeout(() => {
                            item.style.opacity = '1';
                            item.style.transform = 'scale(1) translateY(0)';
                        }, (index % 8) * this.animationDelay);
                        
                        observer.unobserve(item);
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '50px'
            });

            this.items.forEach(item => {
                item.style.transition = 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
                observer.observe(item);
            });
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        const galleryContainer = document.querySelector('.realizations-gallery');
        if (galleryContainer) {
            new RealizationsGallery(galleryContainer);
        }
    });

})();
